/***************************************************************
 * Copyright (c) 2006 - 2022, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 03/29/2022
 *
 * @version 0.2
 * Revisions:
 * 03/29/2022 - BW - Initial Creation
 * 06/17/2022 - BW - Modified: validatePaymentExtra - updated code to include checks
 *                   for:"invalidPaymentFe2List" and "invalidPaymentFe3List"
 *                   Modified: _getPaymentExtraHTML - added code for payemnt2/3
 *
 * Description/Purpose:
 * Payment Extra Invoice JS
 ***************************************************************/
import StackTraceError from "component/stack-trace-error/stack-trace-error";
import CommonUtil from "util/common-util";
import {COMMON as COMMON_PAYMENT_EXTRA, COMMON} from "page/payment/payment-extra-util";
import PUBSUB_EVENT from "constant/pubsub-event";
import PubSub from 'pubsub-js';
import ButtonUtil from "util/button-util";
import AjaxUtil from "util/ajax-util";
import {COMMON as COMMON_PAYMENT_UTIL, TAG_DATA} from "page/payment/payment-util";
import PaymentAjaxResponseJsonDto from "dto/payment-ajax-response-json-dto";
import AjaxResponseUtil from "util/ajax-response-util";
import ModalUtil from "util/modal-util";


const PaymentExtra = {


  /**
   * Init
   * @param $form
   * @returns {PaymentExtra}
   */
  init($form) {
    this._$form = $form;
    this._setUpVariable();
    this._cacheDom();
    this._registerEvent();
    this.addPaymentExtra();
    return this;
  },


  /**
   * Set up some common variables
   * @private
   */
  _setUpVariable() {
    try {
    } catch (e) {
      StackTraceError.processError(e, 'Payment Extra - Set Up Variable');
    }
  },


  /**
   * Caches some often used DOM objects
   * @returns {PaymentExtra}
   * @private
   */
  _cacheDom() {
    try {
      this._$paymentExtraUL = $(`#${COMMON.PAYMENT_EXTRA_UL_ID}`);
      this._$addPaymentExtraButton = $(COMMON.ADD_PAYMENT_EXTRA_BUTTON_SELECTOR);
      this._$paymentExtraContent = $(COMMON.PAYMENT_EXTRA_CONTENT_SELECTOR);
      this._$idCounter = $(COMMON.PAYMENT_EXTRA_ID_COUNTER_SELECTOR);
      this._$invoicePaymentExtraPSV = $(COMMON_PAYMENT_EXTRA.INVOICE_PAYMENT_EXTRA_PSV_SELECTOR);
      this._$paymentButton = $(COMMON_PAYMENT_UTIL.PAYMENT_BUTTON_SELECTOR);
    } catch (e) {
      StackTraceError.processError(e, 'Payment Extra - Cache Dom');
    }
    return this;
  },


  /**
   * Register events or DOM event
   */
  _registerEvent() {
    this._$paymentExtraUL
        .on('click', `.${COMMON.PAYMENT_EXTRA_DELETE_ICON}`,
            ($event) => this._deletePaymentExtra($event));
    this._$addPaymentExtraButton
        .off('click')
        .on('click',
            ($event) => this.addPaymentExtra(null, true));

    return this;
  },


  /**
   * Returns the Payment Extra HTML
   * @param value
   * @returns {string|*}
   * @private
   */
  _getPaymentExtraHTML() {
    const id = parseInt(this._$idCounter.val()) + 1;
    const idPay1 = `${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_VALID_ID}${id}` +
        `${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_VALID_SUFFIX_1_ID}`;
    const idPay2 = `${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_VALID_ID}${id}` +
        `${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_VALID_SUFFIX_2_ID}`;
    const idPay3 = `${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_VALID_ID}${id}` +
        `${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_VALID_SUFFIX_3_ID}`;
    this.__html = `<li class='${COMMON.PAYMENT_EXTRA_LI_CLASS} ${COMMON.PAYMENT_EXTRA_LI_DATA_CLASS}'`
        + `  id='${COMMON.PAYMENT_EXTRA_LI_ID}${id}'>`
        + `  <div class='${COMMON.PAYMENT_EXTRA_DELETE_COLUMN}'>`
        + `    <i class='${COMMON.PAYMENT_EXTRA_DELETE_ICON}'></i>`
        + `  </div>`
        + `  <div class='${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_COLUMN}'>`
        + `    <input type='text' id='${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT_ID}${id}'`
        + `    name='${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT_ID}${id}'`
        + `    class='${COMMON.PAYMENT_EXTRA_INPUT} ${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT}' />`
        + `    <input type='text' id='${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT_VALID_ID}${id}'`
        + `    name='${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT_VALID_ID}${id}'`
        + `    class='hide ${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT_VALID}' value='true' />`
        + `  </div>`
        + `  <div class='${COMMON.PAYMENT_EXTRA_SPACER_COLUMN}'></div>`
        + `  <div class='${COMMON.PAYMENT_EXTRA_PAYMENT_COLUMN}'>`
        + `    <input type='text' id='${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_ID}${id}'`
        + `    name='${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_ID}${id}'`
        + `    class='${COMMON.PAYMENT_EXTRA_INPUT} ${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT}' />`
        + `    <input type='text' id='${idPay1}' name='${idPay1}'`
        + `    class='hide ${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_1_VALID}' value='true' />`
        + `    <input type='text' id='${idPay2}' name='${idPay2}'`
        + `    class='hide ${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_2_VALID}' value='true' />`
        + `    <input type='text' id='${idPay3}' name='${idPay3}'`
        + `    class='hide ${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT_3_VALID}' value='true' />`
        + `  </div>`
        + `</li>`;
    this._$idCounter.val(id);
    return this.__html;
  },


  /**
   * Will add a new Payment Extra Name
   * @param start
   * @param bypass - bypass check and just add the extra rows
   * @param value - the possible input value
   */
  addPaymentExtra(start, bypass, value = '') {
    start = start === undefined || null ? false : start;

    // Should we add a new row?  Only add if the last row has data
    const $lastInvoiceNumberInput = this._$paymentExtraUL.find(`.${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT}`).last();
    const $lastPaymentInput = this._$paymentExtraUL.find(`.${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT}`).last();
    const process = $lastInvoiceNumberInput.val() !== '' || $lastPaymentInput.val() !== '';

    if (start || process || bypass) {
      this._$paymentExtraUL.append(this._getPaymentExtraHTML(value));
      this._addTextChangePaymentExtraEvent();
      this._addOnlyNumbersPaymentExtraEvent();
    }
  },


  /**
   * Will add the text change event to the Payment Extra text input
   * We need to set this each time because the "textchange" event does not work with 'on' and a 'selector'
   * @returns
   */
  _addTextChangePaymentExtraEvent() {
    $(`.${COMMON.PAYMENT_EXTRA_INPUT}`)
        .off('textchange')
        .on('textchange',
            ($event) => {
              this.addPaymentExtra();
            });
    $(`.${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT}`)
        .on('textchange',
            ($event) => {
              PubSub.publish(PUBSUB_EVENT.PAYMENT_EXTRA_TEXT_CHANGE_COMPLETE)
            });
  },


  /**
   * Will add the the "Only Numbers" change event to the Payment inputs
   * @private
   */
  _addOnlyNumbersPaymentExtraEvent() {
    this._$paymentExtraUL
        .find(`.${COMMON.PAYMENT_EXTRA_INPUT}`)
        .onlyNumbers();
  },


  /**
   * Will delete the Payment Extra element only if it is not the last one.
   * If it is the last one - it will just clear it out.
   * @param $event
   */
  _deletePaymentExtra($event = null, $li = null) {
    if ($event !== null) {
      const $elem = $($event.target);
      $li = $elem.parents('li');
    }
    // Do Deleting or Clearing
    if (this._getNumberChildrenPaymentExtra() === 1) {
      $li.find("input[type=text]").val('');
    } else {
      $li.remove();
    }
    PubSub.publish(PUBSUB_EVENT.PAYMENT_EXTRA_DELETE_SUCCESS_COMPLETE);
  },


  /**
   * Will return the number of bates-number-input elements
   * @returns
   */
  _getNumberChildrenPaymentExtra() {
    // don't use cache and "-1 for heading"
    return $(`.${COMMON.PAYMENT_EXTRA_LI_CLASS}`).length - 1;
  },


  /**
   * Will add up and return the total amount of all the "extra" payments
   */
  getTotalAmount() {
    let totalPayment = 0;
    $(`.${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT}`).each((key, value) => {
      const $this = $(value);
      const payment = parseFloat($this.val());
      // Add all payments
      if (payment > 0)
        totalPayment += payment;
    });
    return totalPayment;
  },


  /**
   * Shows the payment extra content
   */
  showPaymentExtraContent() {
    CommonUtil.show(this._$paymentExtraContent);
  },


  /**
   * Hides the payment extra content
   */
  hidePaymentExtraContent() {
    CommonUtil.hide(this._$paymentExtraContent);
    $(`.${COMMON.PAYMENT_EXTRA_LI_DATA_CLASS}`).each((key, value) => {
      const $this = $(value);
      this._deletePaymentExtra(null, $this);
    });
  },


  /**
   * Will return the records
   * @returns
   */
  getInvoicePaymentExtraPSV() {
    let invoicePaymentExtraPSV = "";
    try {
      $(`.${COMMON.PAYMENT_EXTRA_LI_DATA_CLASS}`).each((key, value) => {
        const $this = $(value);
        const $invoiceNumber = $this.find(`.${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT}`);
        const invoiceNumber = $invoiceNumber.val();
        const $payment = $this.find(`.${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT}`);
        const payment = $payment.val();
        if (invoiceNumber.length > 0 && payment.length > 0) {
          invoicePaymentExtraPSV += `${invoicePaymentExtraPSV.length > 0 ? "|" : ""}`;
          invoicePaymentExtraPSV += `${$invoiceNumber.prop('id')}~${$payment.prop('id')}`
              + `~${invoiceNumber}~${payment}`;
        }
      });
    } catch (e) {
      StackTraceError.processError(e, 'Payment Extra - Get Invoice Payment Extra PSV');
    }
    return invoicePaymentExtraPSV;
  },


  /**
   * Will validate the "Extra" invoice numbers
   * @param $event
   * @returns {boolean}
   */
  validatePaymentExtra($event) {

    // Set the invoice payment extra data
    this._$invoicePaymentExtraPSV.val(this.getInvoicePaymentExtraPSV());

    if (this._$invoicePaymentExtraPSV.val().length > 0) {
      try {
        // Saving
        ButtonUtil.enableProcessingButton(this._$paymentButton);

        //  Send ajax call to get the total row count data
        const request = AjaxUtil.postJsonToAjaxServlet(
            TAG_DATA.URL_PAYMENT_SERVLET,
            TAG_DATA.E_ACT_VALIDATE_INVOICE_NUMBER,
            this._$form.serialize(), {},
        );
        request.always((data) => {
          // Always remove the Processing Button
          ButtonUtil.disableProcessingButton(this._$paymentButton);
        });
        request.done((data) => {
          const paymentAjaxResponseJsonDto = new PaymentAjaxResponseJsonDto(data);

          if (AjaxResponseUtil.isBasicAjaxResponseSuccess(paymentAjaxResponseJsonDto)) {
            // Now validate form AFTER the Invoice Number check occurs via Ajax
            $(`.${COMMON_PAYMENT_EXTRA.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT_VALID}`).val('true');
            $(`.${COMMON_PAYMENT_EXTRA.PAYMENT_EXTRA_PAYMENT_INPUT_1_VALID}`).val('true');
            $(`.${COMMON_PAYMENT_EXTRA.PAYMENT_EXTRA_PAYMENT_INPUT_2_VALID}`).val('true');
            $(`.${COMMON_PAYMENT_EXTRA.PAYMENT_EXTRA_PAYMENT_INPUT_3_VALID}`).val('true');
            if (paymentAjaxResponseJsonDto.invalidInvoiceNumberFeList != null &&
                paymentAjaxResponseJsonDto.invalidInvoiceNumberFeList.length > 0) {
              for (let i = 0; i < paymentAjaxResponseJsonDto.invalidInvoiceNumberFeList.length; i++) {
                $(`${COMMON_PAYMENT_EXTRA.PAYMENT_EXTRA_INPUT_VALID_PREFIX_ID_SELECTOR}`
                    + `${paymentAjaxResponseJsonDto.invalidInvoiceNumberFeList[i]}`).val('false');
              }
            }
            if (paymentAjaxResponseJsonDto.invalidPaymentFeList != null &&
                paymentAjaxResponseJsonDto.invalidPaymentFeList.length > 0) {
              for (let i = 0; i < paymentAjaxResponseJsonDto.invalidPaymentFeList.length; i++) {
                $(`${COMMON_PAYMENT_EXTRA.PAYMENT_EXTRA_INPUT_VALID_PREFIX_ID_SELECTOR}`
                    + `${paymentAjaxResponseJsonDto.invalidPaymentFeList[i]}_1`).val('false');
              }
            }
            if (paymentAjaxResponseJsonDto.invalidPaymentFe2List != null &&
                paymentAjaxResponseJsonDto.invalidPaymentFe2List.length > 0) {
              for (let i = 0; i < paymentAjaxResponseJsonDto.invalidPaymentFe2List.length; i++) {
                console.log( `${COMMON_PAYMENT_EXTRA.PAYMENT_EXTRA_INPUT_VALID_PREFIX_ID_SELECTOR}`
                    + `${paymentAjaxResponseJsonDto.invalidPaymentFe2List[i]}_2` );
                $(`${COMMON_PAYMENT_EXTRA.PAYMENT_EXTRA_INPUT_VALID_PREFIX_ID_SELECTOR}`
                    + `${paymentAjaxResponseJsonDto.invalidPaymentFe2List[i]}_2`).val('false');
              }
            }
            if (paymentAjaxResponseJsonDto.invalidPaymentFe3List != null &&
                paymentAjaxResponseJsonDto.invalidPaymentFe3List.length > 0) {
              for (let i = 0; i < paymentAjaxResponseJsonDto.invalidPaymentFe3List.length; i++) {
                $(`${COMMON_PAYMENT_EXTRA.PAYMENT_EXTRA_INPUT_VALID_PREFIX_ID_SELECTOR}`
                    + `${paymentAjaxResponseJsonDto.invalidPaymentFe3List[i]}_3`).val('false');
              }
            }

            // Complete
            PubSub.publish(PUBSUB_EVENT.PAYMENT_EXTRA_VALIDATE_SUCCESS_COMPLETE);

          } else if (AjaxResponseUtil.isBasicAjaxResponseError(paymentAjaxResponseJsonDto)) {
            ModalUtil.showModalFailAlert();
          }

        });
        request.fail((jqXHR, textStatus, errorThrown) => {
          StackTraceError.processErrorWithModalFailAlertWithNotifiedMessage(
              new Error(errorThrown), 'Payment Invoice Validation - Ajax Fail',
              'An error occurred validating invoices and Case Anywhere has been notified.',
          );
          // Always remove the Processing Button
          ButtonUtil.disableProcessingButton(this._$paymentButton);
        });
      } catch (e) {
        StackTraceError.processError(e, 'Payment Invoice Validation - Continue Button Click');
      }

    } else {
      // Complete
      PubSub.publish(PUBSUB_EVENT.PAYMENT_EXTRA_VALIDATE_SUCCESS_COMPLETE);
    }
    return true;
  },


};
export default PaymentExtra;
